import { render, staticRenderFns } from "./uploadFileView.vue?vue&type=template&id=338506b7&scoped=true&"
import script from "./uploadFileView.vue?vue&type=script&lang=js&"
export * from "./uploadFileView.vue?vue&type=script&lang=js&"
import style0 from "./uploadFileView.vue?vue&type=style&index=0&id=338506b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338506b7",
  null
  
)

export default component.exports